import React, { FC, useContext } from 'react'
import { Grid } from '@mui/material'
import { makeStyles } from 'tss-react/mui'
import styles from '../../../styles'
import { FormattedMessage } from 'react-intl'
import { SelectionPaneContext } from './SelectionPaneContext'
import { WHITE } from '../../../theme'
import { prospectTypeEnum } from '../../../enums/prospectTypeEnum'

const ClientCard: FC = () => {
	const { classes, cx } = useStyles()
	const { currentClient } = useContext(SelectionPaneContext)

	const label = cx(
		classes.text6,
		classes.semiBold
	)

	const textStyle = cx(
		classes.text15,
		classes.textStyle
	)

	const renderInfo = (labelPath: string, text?: string) => (
		<Grid container item spacing="5px">
			<Grid container item className={label}>
				<FormattedMessage
					id={labelPath}
					defaultMessage="Nom"
					description="Nom"
				/>
			</Grid>
			<Grid container item className={textStyle}>
				{text || ''}
			</Grid>
		</Grid>
	)

	return (
		<Grid container item className={classes.clientCardContainer}>
			<Grid container item spacing="10px">
				{renderInfo('client.lastname', currentClient?.nom)}
				{
					currentClient?.prospect_type === prospectTypeEnum.CONTACT &&
					renderInfo('client.firstname', currentClient?.prenom)
				}
				{renderInfo('client.email', currentClient?.email)}
				{renderInfo('client.phone', currentClient?.telephone)}
			</Grid>
		</Grid>
	)
}

const useStyles = makeStyles()((theme) => ({
	...styles(theme),
	textStyle: {
		fontWeight: 400,
		overflowWrap: 'anywhere'
	},
	clientCardContainer: {
		backgroundColor: WHITE,
		borderRadius: 20,
		padding: '20px 15px'
	}
}))

export default ClientCard